// src/internal/components/help-center-panel/help-center-article/use-case-components/custom-select.tsx
import { forwardRef, useMemo } from "react";
import { Select } from "@clara/ui";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var COMPANY_MANAGE_SUBSCRIPTION_FIELD_IDS = [
  "29668856660115",
  "29685443668115"
];
var CustomSelect = forwardRef(
  ({ ...props }, ref) => {
    const options = useMemo(() => {
      const container = document.createElement("div");
      container.innerHTML = props.element.innerHTML;
      const options2 = [];
      container.querySelectorAll("div[data-type='option']").forEach((option) => {
        options2.push({
          value: option.getAttribute("data-field-value"),
          label: option.getAttribute("data-label")
        });
      });
      return options2;
    }, [props.element.innerHTML]);
    const value = useMemo(
      () => options.filter((option) => {
        var _a;
        return (_a = props.value) == null ? void 0 : _a.includes(option.value);
      }),
      [options, props.value]
    );
    const setSubject = (value2) => {
      if (value2 && COMPANY_MANAGE_SUBSCRIPTION_FIELD_IDS.includes(props.name)) {
        props.setSubject(value2);
      }
    };
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx("input", { type: "hidden", ref, value: value.map((v) => v.value) }),
      /* @__PURE__ */ jsx(
        Select,
        {
          ...props,
          isMulti: props.element.getAttribute("data-multi") === "true",
          onChange: (newValue) => {
            if (Array.isArray(newValue)) {
              const values = newValue == null ? void 0 : newValue.map(
                (option) => option.value
              );
              props.onChange(values.length ? values : void 0);
            } else {
              const option = newValue;
              setSubject(option == null ? void 0 : option.label);
              props.onChange(option == null ? void 0 : option.value);
            }
          },
          label: props.label,
          options,
          value,
          isClearable: true
        }
      )
    ] });
  }
);
CustomSelect.displayName = "CustomSelect";
var custom_select_default = CustomSelect;

export {
  custom_select_default
};
